module.exports = __webpack_public_path__ + "img/vcr_large.6f4acd67.png";